export const REDIRECT_URL = process.env.REACT_APP_ENS_FRONTEND_URL || 'http://localhost:81/';
export const ENS_CLIENTID = process.env.REACT_APP_ENS_CLIENTID || '449883d6-428b-4e5d-b4a9-06ba1d327ef5';
export const EORICUSTOMTECH_DOMAIN = process.env.REACT_APP_EORICUSTOMTECH_DOMAIN || 'Eoricustomtech';
export const EORICUSTOMTECH_TENANTID =
  process.env.REACT_APP_EORICUSTOMTECH_TENANTID || 'e43f36b5-975f-4983-8447-eec73ed210ed';
export const LANDINGPAGE_URL = process.env.REACT_APP_SSO_FRONTEND_URL || 'http://localhost:3000/';

const trimmedRedirectUrl = REDIRECT_URL.endsWith('/') ? REDIRECT_URL.slice(0, -1) : REDIRECT_URL;
export const blankRedirectUrl = trimmedRedirectUrl + '/blank.html';

export const msalConfig = {
  auth: {
    clientId: ENS_CLIENTID,
    authority: `https://${EORICUSTOMTECH_DOMAIN}.ciamlogin.com/${EORICUSTOMTECH_TENANTID}/v2.0/`,
    knownAuthorities: [`${EORICUSTOMTECH_DOMAIN}.ciamlogin.com`],
    redirectUri: REDIRECT_URL,
    postLogoutRedirectUri: LANDINGPAGE_URL,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};
